import NRS from '@/views/constants/report-of-sickness-new';
import { ReportOfSickness } from '@/resources/models/reports-of-sickness';
import ReportsOfSicknessResource from '@/resources/constants/reports-of-sickness';
import ReportsOfSicknessView from '@/views/constants/reports-of-sickness';

import NewReportOfSicknessValidator from '@/views/validations/report-of-sickness-new';

const state = {
  newReportOfSickness: new ReportOfSickness()
};

const getters = {
  newReportOfSickness: state => state.newReportOfSickness,

  newReportOfSicknessRequiredFields: state => NewReportOfSicknessValidator.requiredFields(state.newReportOfSickness),
  newReportOfSicknessValidations: state => NewReportOfSicknessValidator.validate(state.newReportOfSickness)
};

const actions = {
  [NRS.Actions.Form.CHANGE] ({ commit }, data) {
    commit(NRS.Mutations.Form.CHANGE, data);
  },

  [ReportsOfSicknessResource.Actions.Create.SUCCESS] ({ commit }) {
    commit(NRS.Mutations.CLEAR);
  },

  [NRS.Actions.Cancel.DO] ({ commit }) {
    commit(NRS.Mutations.CLEAR);
  },

  [ReportsOfSicknessView.Actions.Tabs.CLOSE] ({ commit }, tab) {
    if (tab.component === 'NewReportOfSickness') {
      commit(NRS.Mutations.CLEAR);
    }
  }
};

const mutations = {
  [NRS.Mutations.CLEAR] (state) {
    state.newReportOfSickness = new ReportOfSickness();
  },

  [NRS.Mutations.Form.CHANGE] (state, payload) {
    state.newReportOfSickness[payload.attribute] = payload.value;
    if (payload.attribute === 'accident') {
      if (state.newReportOfSickness.accident === false) {
        state.newReportOfSickness.thirdPartyLiability = null;
      }
    }
  }
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
